import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { AdminIcon } from "./icon";

interface AlertBannerProps {
	variant: "warning" | "danger" | "info";
	title: string;
	description?: ReactNode;
	actions?: ReactNode;
}

export function AlertBanner({
	variant,
	title,
	description,
	actions,
}: AlertBannerProps) {
	return (
		<div className={cn("alert-banner", variant)}>
			<span className="icn">
				<AdminIcon n={variant === "info" ? "info" : "alert"} s={20} />
			</span>
			<div className="body">
				<strong>{title}</strong>
				{description && <span>{description}</span>}
			</div>
			{actions && <div className="acts">{actions}</div>}
		</div>
	);
}
